import {
  LuChevronDown,
  FiCalendar,
} from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      // columnWidth:"45%",
      rows: {
        row1: [
        
          {
            name: "AuthorizedSignatory",
            label : "AuthorizedSignatory",
            component: "header",
          },
        ],
        row2: [
          {
            name: "namePrefix",
            label: "Name",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
             options : [
              {label : "Mrs",value : "Mrs"},
              {label : "Mr",value : "Mr"}
            ]
          },
          {
            name: "name",
            component: "text-field",
           
          },
        ],
        row3: [
          {
            name: "dateOfBirth",
            label: "Date Of Birth",
            component: "dateselector",
            endIconName: FiCalendar,
            iconColor: "gray-400",
            width:"50%"
          },
          {
            name: "sex",
            formlabel: "Sex",
            component: "radiobutton",
            // defaultValue: "Male",
            options: [
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
            ],

          },
        ],
        row4: [
          {
            name: "address",
            actionText: "Address",
            component: "textarea",
            width: "100%",
            sx: {
              borderRadius: 10,
            },
          },

        ],
        row6: [
          {
            name: "city",
            label: "City",
            component: "text-field",
            endpoint : "getCityMaster",
            type : "autocomplete"
          },
          {
            name: "state",
            label: "State",
            component: "text-field",
            type : "autocomplete",
            endpoint : "getStateMaster"
          },

        ],
        row7: [
          {
            name: "telephone",
            label: "Telephone",
            component: "text-field",
          },
          {
            name: "mobile",
            label: "Mobile",
            component: "text-field",
          },

        ],

        row8: [
          {
            name: "fax",
            label: "Fax",
            component: "text-field",
          },
          {
            name: "email",
            label: "Email",
            component: "text-field",
          },

        ],
        row9 : [
          {
            name : "photographFileId",
            label:"Select Picture",
            component: "fileselector",
            allowedFileTypes: "JPG,JPEG,PNG",
            width : "50%",
          }
        ]
      },
    },
    // {
    //   column: "column2",
    //   columnWidth:"45%",
    //   rows: {
    //     row1: [
    //       {
    //         name: "photographFileId",
    //         label:"SelectPicture",
    //         component: "image",
    //         multiple: false,               // or true for multiple uploads
    //         accept: "image/png, image/jpeg",
    //         acceptLabel: "Only JPG, JPEG, PNG files allowed",             // optional
    //         sx: { mt: 8,ml:10 },   
    //         uploadSx: { borderColor: "primary.main" } // extra style for upload box
    //       }
    //     ],
    //   },
    // },
  ],
};
